import apiClient from '../../../shared/api/client';

export const getPacienteInformeById = async (pacienteId) => {
  const { data } = await apiClient.get(`/pacientes/informes/${pacienteId}`);
  return data;
};

export const getEntrevistaById = async (entrevistaId) => {
  const { data } = await apiClient.get(`/entrevista/${entrevistaId}`);
  return data;
};

export const createEntrevista = async ({ pacienteId, payload }) => {
  const { data } = await apiClient.post(`/entrevistas/${pacienteId}`, payload);
  return data;
};

export const getEntrevistas = async () => {
  const { data } = await apiClient.get('/entrevistas');
  return data;
};

export const updateEntrevista = async ({ codigoEntrevista, payload }) => {
  const { data } = await apiClient.put(`/entrevistas/${codigoEntrevista}`, payload);
  return data;
};

export const deleteEntrevista = async (codigoEntrevista) => {
  const { data } = await apiClient.delete(`/entrevistas/${codigoEntrevista}`);
  return data;
};

export const updatePaciente = async ({ pacienteId, payload }) => {
  const { data } = await apiClient.put(`/pacientes/${pacienteId}`, payload);
  return data;
};
